const UnlockedBadgeIcon = () => (
  <svg fill="none" height="11" viewBox="0 0 10 11" width="10" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#00BD00" height="10" rx="5" width="10" y="0.5" />
    <path d="M7.5 4.5L4 7.5L2.5 6" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default UnlockedBadgeIcon;
